import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Body } from '@nerdwallet/react-typography';

import HeroNavTile from './hero-nav-tile';

const HeroNav = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile, nav) => (
    <HeroNavTile {...tile} key={`item-${nav}`} />
  ));

  const HeroContainer = (
    <div className="hero-nav__container">{renderedTiles}</div>
  );

  return (
    <div className="hero-nav__box">
      <Body size="large" className="hero-nav__header">
        Let’s crush your money goals. Where do you want to start?
      </Body>
      {HeroContainer}
    </div>
  );
};

HeroNav.displayName = 'HeroNav';

HeroNav.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(HeroNav.propTypes)),
  className: PropTypes.string,
  nav: PropTypes.string,
};

export default HeroNav;
